import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';

class PreTransferFte extends Component {
    state = {
        visible: false,
    }

    record = {}

    columns = []

    dataSource = []

    show = (record) => {
        this.record = record;
        this.parseData(record.estimateHandOverFtes);
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    parseData = (data) => {
        const columns = [{
            title: '时间',
            dataIndex: 'time',
            key: 'time',
            fixed: 'left',
            width: 80,
        }];
        const params = { time: 'FTE' };
        (data || []).forEach(item => {
            const { year, month, planFte } = item;
            const date = `${year}.${month}`;
            columns.push({
                title: date,
                dataIndex: date,
                key: date,
                width: 60,
            });
            params[date] = planFte;
        });
        this.columns = columns;
        this.dataSource = [params];
    }

    render() {
        const { visible } = this.state;
        const { requirementCode } = this.record;
        return (
            <Modal
                title='预计交接的FTE'
                visible={visible}
                onCancel={this.hide}
                width={800}
                maskClosable={false}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ marginBottom: 10 }}>交接编号：{requirementCode}</div>
                <TableC
                    columns={this.columns}
                    data={this.dataSource}
                    className="preTransferFte"
                />
            </Modal>
        );
    }
}

export default PreTransferFte;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/PreTransferFte.js